import React, { useContext } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';

import ViewsFrontIcon from '../../assets/image/toolbar/views_front.svg';
import ViewsBackIcon from '../../assets/image/toolbar/views_back.svg';
import ViewsTopIcon from '../../assets/image/toolbar/views_top.svg';
import ViewsBottomIcon from '../../assets/image/toolbar/views_bottom.svg';
import ViewsRightIcon from '../../assets/image/toolbar/views_right.svg';
import ViewsLeftIcon from '../../assets/image/toolbar/views_left.svg';
import ZoomFitIcon from '../../assets/image/toolbar/zoom_fit.svg';
import TrueColorOnIcon from '../../assets/image/toolbar/true_color_on.png';
import TrueColorOffIcon from '../../assets/image/toolbar/true_color_off.png';
import LightIcon from '../../assets/image/toolbar/light.svg';
import LightOffIcon from '../../assets/image/toolbar/light_off.svg';
import ResetIcon from '../../assets/image/toolbar/reset.svg';
import SnapshotIcon from '../../assets/image/toolbar/snapshot.svg';
import { ToolID, ViewOrientation } from '../shared/common';
import TooltipButton from '../shared/TooltipButton';

import { AppContext } from '../App';
import Tr from '../shared/tr';

const buttonSize = 32;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      height: buttonSize,
    },
    toolbar: {
      height: buttonSize,
      minHeight: buttonSize,
      padding: 0,
    },
    button: {
      borderRadius: 4,
      width: buttonSize,
      height: buttonSize,
      border: 'none',
      '&:hover': {
        background: 'rgba(54, 176, 201, 1)',
      },
      pointerEvents: 'all',
    },
    title: {
      flexGrow: 1,
    },
  })
);

export default function SecondaryToolbar(props: SecondaryToolbarProps) {
  const classes = useStyles();
  const { light, setLight, color, setColor, textureMesh, currentTool } = useContext(AppContext);
  const tr = new Tr();

  const handleOrientationChange = (val: ViewOrientation) => {
    if (props && props.onViewOrientationChange) {
      props.onViewOrientationChange(val);
    }
    console.log('handleOrientationChange:' + ViewOrientation[val]);
  };

  const isOcclu: boolean = currentTool === ToolID.OcclusionMapping;

  const isLightEnable: boolean = textureMesh && color;

  return (
    <div className={classes.root}>
      <Toolbar className={classes.toolbar}>
        <TooltipButton
          className={classes.button}
          title={tr.orientFront()}
          imgSrc={ViewsFrontIcon}
          onClick={() => {
            handleOrientationChange(ViewOrientation.Front);
          }}
          name="canvasToolbar.btnViewFront"
        />
        <TooltipButton
          className={classes.button}
          title={tr.orientBack()}
          imgSrc={ViewsBackIcon}
          onClick={() => {
            handleOrientationChange(ViewOrientation.Back);
          }}
          name="canvasToolbar.btnViewBack"
        />
        <TooltipButton
          className={classes.button}
          title={tr.orientTop()}
          imgSrc={ViewsTopIcon}
          onClick={() => {
            handleOrientationChange(ViewOrientation.Top);
          }}
          name="canvasToolbar.btnViewTop"
        />
        <TooltipButton
          className={classes.button}
          title={tr.orientBottom()}
          imgSrc={ViewsBottomIcon}
          onClick={() => {
            handleOrientationChange(ViewOrientation.Bottom);
          }}
          name="canvasToolbar.btnViewBottom"
        />
        <TooltipButton
          className={classes.button}
          title={tr.orientRight()}
          imgSrc={ViewsRightIcon}
          onClick={() => {
            handleOrientationChange(ViewOrientation.Right);
          }}
          name="canvasToolbar.btnViewRight"
        />
        <TooltipButton
          className={classes.button}
          title={tr.orientLeft()}
          imgSrc={ViewsLeftIcon}
          onClick={() => {
            handleOrientationChange(ViewOrientation.Left);
          }}
          name="canvasToolbar.btnViewLeft"
        />
        <TooltipButton
          className={classes.button}
          title={tr.zoomFit()}
          imgSrc={ZoomFitIcon}
          onClick={() => {
            if (props.onZoomFit) {
              props.onZoomFit();
            }
          }}
          name="canvasToolbar.btnZoomFit"
        />
        <TooltipButton
          className={classes.button}
          title={tr.takeSnapshot()}
          imgSrc={SnapshotIcon}
          onClick={() => {
            if (props.onSnapshot) {
              props.onSnapshot();
            }
          }}
          name="canvasToolbar.btnTakeSnapshot"
        />
        {!isOcclu && (
          <TooltipButton
            className={classes.button}
            title={tr.switchTrueColor()}
            imgSrc={color ? TrueColorOnIcon : TrueColorOffIcon}
            onClick={() => {
              setColor((v) => !v);
            }}
            name="canvasToolbar.btnToggleTrueColor"
          />
        )}
        {!isOcclu && (
          <TooltipButton
            className={classes.button}
            title={tr.switchLight()}
            disabled={!isLightEnable}
            imgSrc={light ? LightIcon : LightOffIcon}
            onClick={() => {
              setLight((v) => !v);
            }}
            name="canvasToolbar.btnToggleLight"
          />
        )}
        <TooltipButton
          className={classes.button}
          title={tr.reset()}
          imgSrc={ResetIcon}
          onClick={() => {
            if (props.onReset) {
              props.onReset();
            }
          }}
          name="canvasToolbar.btnReset"
        />
      </Toolbar>
    </div>
  );
}

interface SecondaryToolbarProps {
  onViewOrientationChange?: (val: ViewOrientation) => void;
  onZoomFit?: () => void;
  onReset?: () => void;
  onSnapshot?: () => void;
}
